export interface FacebookSDK {
  login: (callback: (response: FacebookLoginResponse) => void, options: FacebookLoginOptions) => void;
}

export interface FacebookLoginResponse {
  authResponse: {
    code: string;
    expiresIn: number;
    userID: string;
  } | null;
  status: 'connected' | 'not_authorized' | 'unknown';
}

export interface FacebookLoginOptions {
  config_id: string;
  response_type: string;
  override_default_response_type: boolean;
  extras?: Record<string, unknown>;
}

export interface SessionInfo {
  data: FinishData | CancelData;
  type: SessionInfoType;
  event: SessionInfoEvent;
}

export enum SessionInfoType {
  WA_EMBEDDED_SIGNUP = 'WA_EMBEDDED_SIGNUP'
}

export enum SessionInfoEvent {
  FINISH = 'FINISH',
  ERROR = 'ERROR',
  CANCEL = 'CANCEL'
}

export interface FinishData {
  phone_number_id: string;
  waba_id: string;
}

export interface CancelData {
  current_step: CurrentStep;
}

export enum CurrentStep {
  BUSINESS_ACCOUNT_SELECTION = 'BUSINESS_ACCOUNT_SELECTION',
  WABA_PHONE_PROFILE_PICKER = 'WABA_PHONE_PROFILE_PICKER',
  WHATSAPP_BUSINESS_PROFILE_SETUP = 'WHATSAPP_BUSINESS_PROFILE_SETUP',
  PHONE_NUMBER_SETUP = 'PHONE_NUMBER_SETUP',
  PHONE_NUMBER_VERIFICATION = 'PHONE_NUMBER_VERIFICATION',
  PERMISSIONS = 'PERMISSIONS'
}
